import React from 'react'
import { useRoutes } from 'react-router-dom'
import { Routes } from '../../shared/enum'
import { Id, Root } from './pages'

export const SupervisoryController = () => {
  return useRoutes([
    { path: Routes.ROOT, element: <Root /> },
    { path: Routes.ID, element: <Id /> },
  ])
}
